import { ApplicationConfig, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideRouter,
  withComponentInputBinding,
  withDebugTracing,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from '@app/app.routes';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { StyleVariablesService } from '@services/style-variables.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withComponentInputBinding(),
      // TODO: remove once router link issues are diagnosed — logs every router event to the console.
      withDebugTracing(),
    ),
    provideAppInitializer(async () => {
      const styleVariables = inject(StyleVariablesService);
      try {
        const { variables } = await styleVariables.fetch();
        styleVariables.apply(variables);
      } catch {
        // Compiled defaults in styles.scss already apply — nothing to do.
      }
    }),
  ],
};
